import React from 'react';
import { styled } from 'themes';
import { device } from 'themes/media-queries';
import Button from 'components/buttons';
import { useTranslation } from 'react-i18next';

const Support = () => {
  const [t] = useTranslation();
  return (
    <Section>
      <Content>
        <Heading>{t('support.heading')}</Heading>
        <Button
          label={t('support.buttonLabel')}
          to={'https://support.yepstr.com'}
        />
      </Content>
    </Section>
  );
};

const Section = styled.section`
  grid-column: full-start / full-end;
  background-color: ${({ theme }) => theme.colors.silver};
  padding: 5rem 0;

  display: grid;
  grid-template-columns:
    [full-start] minmax(6rem, 1fr) [semi-full-start] minmax(6rem, 1fr) [center-start]
    repeat(8, [col-start] minmax(min-content, 18rem) [col-end])
    [center-end] minmax(6rem, 1fr) [semi-full-end] minmax(6rem, 1fr) [full-end];

  @media ${device.laptop} {
    grid-template-columns:
      [full-start] minmax(3rem, 1fr) [semi-full-start] minmax(3rem, 1fr) [center-start]
      repeat(8, [col-start] minmax(min-content, 18rem) [col-end])
      [center-end] minmax(3rem, 1fr) [semi-full-end] minmax(3rem, 1fr) [full-end];
  }

  @media ${device.mobileL} {
    padding-top: 2rem;
    padding-bottom: 2rem;

    grid-template-columns:
      [full-start] minmax(1rem, 1fr) [semi-full-start] minmax(1rem, 1fr) [center-start]
      repeat(8, [col-start] minmax(min-content, 18rem) [col-end])
      [center-end] minmax(1rem, 1fr) [semi-full-end] minmax(1rem, 1fr) [full-end];
  }
`;

const Content = styled.div`
  grid-column: center-start / center-end;
`;

const Heading = styled.h3`
  margin-bottom: 2rem;
`;

export default Support;
